import {useCallback} from "react";
import {useEffectivePermissionsContext} from "./UseEffectivePermissionsContext";

export const useHasAllPermissions = (): (requiredPermissions: string[]) => boolean => {
    const {effectivePermissions} = useEffectivePermissionsContext();

    return useCallback((requiredPermissions: string[]) => {
        return requiredPermissions.every(permission => effectivePermissions.includes(permission));
    }, [effectivePermissions])
}